import { __assign, __rest } from "tslib";
import React from 'react';
import { ARROW_DOWN_ICON } from '@marvelapp/theme';
import { Box, CircleButton, Icon, Tooltip } from '@marvelapp/ui';
export default function MoveDownButton(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Box, { marginRight: 2 },
        React.createElement(Tooltip, { content: "Move section down" },
            React.createElement(CircleButton, __assign({ bg: "white", "data-testid": "move-section-down-button", hoverBg: "white" }, props),
                React.createElement(Icon, { display: "block", height: 20, paths: ARROW_DOWN_ICON, width: 20 })))));
}
